import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Select2Data } from 'ng-select2-component';

import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';

declare let $: any;
@Component({
  selector: 'app-exit-managment',
  templateUrl: './exit-managment.component.html',
  styleUrls: ['./exit-managment.component.scss'],
})
export class ExitManagmentComponent implements OnInit {
  resignationForm: FormGroup;
  loading: boolean;
  result: any = [];
  exitList: any[];
  empList: Select2Data = [];
  submitted: boolean;
  docsFile: any = [];
  vlgpId: number;
  response: any = [];
  voltryList: any;
  resReson: any = [];
  reasonList: any;
  potentialData: any;
  blacklistData: any;
  minDate: any = new Date();
  public clearanceList: any;
  public onBehalfUser = false;
  exitStatus: any;
  userID: any;
  minLastDate: any;
  public noticPeriod: any = 0;
  public Diss = false;
  firstDay: Date;
  CurDat: any;
  today: any;
  public headerDate = 'Resign Date';
  public showDateFeild = true;
  newDate: any;

  isRhr = false;
  behalfEmp: any;
  onBehalf = false;
  encMrfId: any;
  reportiesCount: any = 0;
  constructor(
    private formBuilder: FormBuilder,
    private exitService: DashboardService,
    private notifyService: NotificationService,
    private router: Router,
    private httpGeneral: GeneralService,
    private talentService: TalentService
  ) {}

  ngOnInit(): void {
    this.minDate = this.formatDate(this.minDate);
    const date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    //console.log(this.firstDay);

    this.CurDat = moment().startOf('month').format('YYYY-MM-DD');
    this.today = moment().format('YYYY-MM-DD');

    // this.getVouluntaryGrp();
    this.resignationFormField();
    this.getMyReporties();
    this.checkEmpExitStatus();
    this.getRoles();
    // this.getClearanceChklist();
    this.potentialData = [
      {
        value: '0',
        label: 'Yes',
      },
      {
        value: '1',
        label: 'No',
      },
    ];
    this.blacklistData = [
      {
        value: '1',
        label: 'Yes',
      },
      {
        value: '0',
        label: 'No',
      },
    ];

    this.exitService
      .getExitMod({ group_id: 18, is_behalf: 0 })
      .subscribe((res) => {
        this.response = res;
        // console.log('vl', this.response);value
        if (this.response.status === true) {
          this.voltryList = this.response.data;
        } else {
          this.voltryList = [
            { label: 'No Data Found', value: '', disabled: true },
          ];
        }
      });
  }

  get resignDate(): any {
    return this.resignationForm.get('resignDate').value;
  }

  chkNotice(event): void {
    //console.log(event.target.value);
    let selectDate = event.target.value;
    // this.theDate = new Date();
    selectDate = new Date(event.target.value);
    selectDate.setDate(selectDate.getDate() + this.noticPeriod);
    selectDate = this.formatDate1(selectDate);
    //console.log('selectDate', selectDate);
    this.minLastDate = selectDate;
    //console.log(this.minLastDate);
    this.resignationForm.patchValue({
      lastDate: this.minLastDate,
    });
  }
  // tslint:disable-next-line: typedef
  formatDate1(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  formatDate(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  get on_behalf_1(): any {
    return this.resignationForm.get('on_behalf_1').value;
  }

  get exitErrorMsg(): any {
    return this.resignationForm.controls;
  }
  getMyReporties(): void {
    this.exitService.getMyReporties().subscribe((res) => {
      this.result = res;
      this.empList = this.result.data;
      this.onBehalfUser = this.result.is_behalf_user;
      this.userID = this.result.id;
      // console.log(this.onBehalfUser);
      this.getClearanceChklist(this.userID);
      if (this.onBehalfUser == false) {
        this.exitMgmtNo();
      }
    });
  }
  changIsOnBefalf(event): void {
    this.resignationForm.patchValue({
      vltry_id: '',
      rsn_id: '',
    });
    this.reasonList = [{ label: '', value: '', disabled: true }];
    let emId;
    emId = event.target.value;
    this.reportiesCount = 0;
    this.resignationForm.patchValue({
      rpls_rm_username: '',
      rpls_rm_id: '',
    });
    if (emId == 0) {
      this.onBehalf = true;
      this.exitMgmtNo();
      this.resignationForm.get('emp').reset();
      this.resignationForm.get('emp').disable();
    } else if (emId == 1) {
      this.onBehalf = false;
      this.resignationForm.get('emp').enable();
      this.resignationForm.get('emp').reset();
      this.resignationForm.patchValue({
        empId: '',
        emp_name: '',
        mobile: '',
        resignDate: '',
        lastDate: '',
        comments: '',
        doc: '',
        vltry_id: '',
        rsn_id: '',
        win_back: '',
        is_blacklist: '',
      });
    } else if (emId == '' || emId == null || emId == undefined) {
      this.resignationForm.patchValue({
        empId: '',
        emp_name: '',
        mobile: '',
        resignDate: '',
        lastDate: '',
        comments: '',
        doc: '',
        vltry_id: '',
        rsn_id: '',
        win_back: '',
        is_blacklist: '',
      });
    } else {
      this.resignationForm.patchValue({
        empId: '',
        emp_name: '',
        mobile: '',
        resignDate: '',
        lastDate: '',
        comments: '',
        doc: '',
        vltry_id: '',
        rsn_id: '',
        win_back: '',
        is_blacklist: '',
      });
    }

    this.exitService
      .getExitMod({ group_id: 18, is_behalf: emId,emp_id: 0 })
      .subscribe((res) => {
        this.response = res;
        // console.log('vl', this.response);value
        if (this.response.status === true) {
          this.voltryList = this.response.data;
        } else {
          this.voltryList = [
            { label: 'No Data Found', value: '', disabled: true },
          ];
        }
      });
  }

  getRoles(): void {
    this.exitService.onBehalfRoles().subscribe((res) => {
      if (res.is_on_behalf_role == 0) {
        this.isRhr = false;
      } else {
        this.isRhr = true;
      }
    });
  }

  exitMgmtNo(): void {
    this.behalfEmp = '';
    this.exitService.exitMgmtNo().subscribe((res) => {
      this.result = res;
      //console.log(this.result);
      this.noticPeriod = this.result.data.notice_period;
      this.behalfEmp = this.result.data.id;
      this.resignationForm.patchValue({
        on_behalf_1: 0,
        empId: this.result.data.username,
        id: this.result.data.id,
        emp_name: this.result.data.name,
        mobile: this.result.data.mobile,
        notice_period: this.result.data.notice_period,
      });
    });
  }

  onChangeEmp(event): void {
    let emId;
    emId = event.value;
    this.behalfEmp = '';
    if (emId === '' || emId == null || emId === undefined) {
      this.resignationForm.patchValue({
        empId: '',
        emp_name: '',
        mobile: '',
        resignDate: '',
        lastDate: '',
        comments: '',
        doc: '',
        vltry_id: '',
        rsn_id: '',
        win_back: '',
        is_blacklist: '',
      });
    } else {
      this.resignationForm.get('emp').reset();
      this.behalfEmp = event.value;
      this.getExitMgmt(emId);
      this.getClearanceChklist(emId);
      this.resignationForm.patchValue({
        empId: '',
        emp_name: '',
        mobile: '',
        resignDate: '',
        lastDate: '',
        comments: '',
        doc: '',
        vltry_id: '',
        rsn_id: '',
        win_back: '',
        is_blacklist: '',
      });
    }
    this.exitService.getExitMod({ group_id: 18, is_behalf: 1,emp_id: emId }).subscribe((res) => {
        this.response = res;
        // console.log('vl', this.response);value
        if (this.response.status === true) 
        {
          this.voltryList = this.response.data;
          if (this.response.user_cate === 2) 
          {
            this.blacklistData = [{value: '0',label: 'NO',},];
            this.potentialData = [{value: '0',label: 'Yes',},];
          }
          else
          {
            this.potentialData = [{value: '0',label: 'Yes',},{value: '1',label: 'No',},];
            this.blacklistData = [{value: '1',label: 'Yes',},{value: '0',label: 'No',},];
          }
        } 
        else 
        {
          this.voltryList = [
            { label: 'No Data Found', value: '', disabled: true },
          ];
        }
      });
  }

  onChangeVltry(event): void {
    let vlId;
    vlId = event.value;
    this.reasonList = [{ label: '', value: '', disabled: true }];
    if (vlId == null || vlId === undefined || vlId === '') {
    } else {
      this.onChangeExitVltry(vlId);
    }
    this.resignationForm.patchValue({
      rsn_id: '',
    });
  }

  onChangeReason(event): void {
    let rnID;
    rnID = event.value;
    //console.log(rnID);
    if (rnID === 69) {
      this.headerDate = 'Last Working Date';
      this.showDateFeild = false;
    } else if (rnID === 73) {
      this.headerDate = 'Last Working Date';
      this.showDateFeild = false;
      this.resignationForm.patchValue({
        notice_period: 0,
      });
    } else {
      this.headerDate = 'Resign Date';
      this.showDateFeild = true;
    }
  }

  // getVouluntaryGrp(): void {
  //   this.vlgpId = 18;
  //   this.exitService.getModOptions(this.vlgpId).subscribe((res) => {
  //     this.response = res;
  //     // console.log('vl', this.response);value
  //     if (this.response.status === true) {
  //       this.voltryList = this.response.data;
  //     } else {
  //       this.voltryList = [
  //         { label: 'No Data Found', value: '', disabled: true },
  //       ];
  //     }
  //   });
  // }
  onChangeExitVltry(vlId): void {
    this.resignationForm.patchValue({
      rsn_id: '',
    });
    //console.log(vlId.value);
    this.exitService
      .getExitReasonsOption({
        vlId: vlId,
        is_behalf: this.resignationForm.get('on_behalf_1').value,
      })
      .subscribe((res) => {
        this.resReson = res;
        //console.log('rn', this.resReson);
        if (this.resReson.status === true) {
          this.reasonList = this.resReson.data;
        } else {
          this.reasonList = [
            { label: 'No Data Found', value: '', disabled: true },
          ];
        }
      });
  }
  getReasonsOption(vlId): void {
    this.exitService.getReasonsOption(vlId).subscribe((res) => {
      this.resReson = res;
      //console.log('rn', this.resReson);
      if (this.resReson.status === true) {
        this.reasonList = this.resReson.data;
      } else {
        this.reasonList = [
          { label: 'No Data Found', value: '', disabled: true },
        ];
      }
    });
  }

  getExitMgmt(emId): void {
    this.reportiesCount = 0;
    this.resignationForm.patchValue({
      rpls_rm_username: '',
      rpls_rm_id: '',
    });
    this.exitService.exitMgmt(emId).subscribe((res) => {
      console.log(res);
      this.result = res;
      //console.log(this.result);
      this.noticPeriod = this.result.data.notice_period;
      if (
        this.result.reporties_count != null &&
        this.result.reporties_count != '' &&
        this.result.reporties_count != '0'
      ) {
        this.reportiesCount = this.result.reporties_count;
      }

      this.resignationForm.patchValue({
        empId: this.result.data.username,
        id: this.result.data.id,
        emp_name: this.result.data.name,
        mobile: this.result.data.mobile,
        user_cate: this.result.data.user_cate,
        hiring_type: this.result.data.hiring_type,
        notice_period: this.result.data.notice_period,
      });
    });
  }
  srchEmpRpls(): void {
    if (!this.resignationForm.get('rpls_rm_username').value) {
      this.notifyService.showInfo('Please enter EmpID', 'Info !');
      return;
    } else {
      this.httpGeneral
        .searchEmployeeMapped(
          this.resignationForm.get('rpls_rm_username').value
        )
        .subscribe((res) => {
          if (res.status) {
            // this.resignationForm.get('emp').reset();
            // this.behalfEmp = res.data[0].id;
            // this.getExitMgmt(this.behalfEmp);
            // this.getClearanceChklist(this.behalfEmp);
            this.resignationForm.patchValue({
              rpls_rm_id: res.data[0].id,
              rpls_rm_username: res.data[0].username + ' ' + res.data[0].name, // + '' + res.data[0].lname,
            });
          } else {
            this.resignationForm.patchValue({
              rpls_rm_id: '',
              rpls_rm_username: '',
            });
            this.notifyService.showError(res.msg, 'Error!');
          }
        });
    }
  }

  srchEmp(): void {
    this.behalfEmp = '';
    this.resignationForm.get('on_behalf').reset();
    if (!this.resignationForm.get('emp').value) {
      this.notifyService.showInfo('Please enter EmpID', 'Info !');
      return;
    } else {
      this.httpGeneral
        .searchEmployeeMapped(this.resignationForm.get('emp').value)
        .subscribe((res) => {
          if (res.status) {
            this.resignationForm.get('emp').reset();
            this.behalfEmp = res.data[0].id;
            this.getExitMgmt(this.behalfEmp);
            this.getClearanceChklist(this.behalfEmp);
            this.exitService.getExitMod({ group_id: 18, is_behalf: 1,emp_id: this.behalfEmp }).subscribe((res) => {
              this.response = res;
              if (this.response.status === true) {
                this.voltryList = this.response.data;
                if (this.response.user_cate === 2) 
                {
                  this.blacklistData = [{value: '0',label: 'No',},];
                  this.potentialData = [{value: '0',label: 'Yes',},];
                }
                else
                {
                  this.potentialData = [{value: '0',label: 'Yes',},{value: '1',label: 'No',},];
                  this.blacklistData = [{value: '1',label: 'Yes',},{value: '0',label: 'No',},];
                }
              } else {
                this.voltryList = [
                  { label: 'No Data Found', value: '', disabled: true },
                ];
              }
            });
          } else {
            this.resignationForm.patchValue({
              emp: '',
              on_behalf: '',
            });
            this.notifyService.showError(res.msg, 'Error!');
          }
        });
        
    }
  }

  resignationFormField(): void {
    this.resignationForm = this.formBuilder.group({
      on_behalf_1: [''],
      emp: [''],
      empId: ['', Validators.required],
      id: [''],
      emp_name: [''],
      on_behalf: [''],
      mobile: [''],
      user_cate: ['0'],
      hiring_type: ['0'],
      resignDate: ['', Validators.required],
      lastDate: [''],
      uniform: ['0'],
      comments: ['', Validators.required],
      doc: [''],
      vltry_id: ['', Validators.required],
      rsn_id: ['', Validators.required],
      win_back: [''],
      is_blacklist: [''],
      notice_period: [''],
      rpls_rm_id: [''],
      rpls_rm_username: [''],
    });
  }

  onSubmitResignation(): void {
    if (this.reportiesCount > 0) {
      if (this.resignationForm.get('rpls_rm_id').value == '') {
        this.notifyService.showError(
          'Please update new reporting manager for this resigning employee reportiees'
        );
        return;
      }
    }
    
    if (this.resignationForm.get('doc').value == '' && this.resignationForm.get('user_cate').value == '0') {
      this.notifyService.showError(
        'Document is required !'
      );
      return;
    }
    this.submitted = true;
    if (this.resignationForm.invalid) {
      return;
    }
    // this.loading = true;
    const skilFormData = new FormData();
    const emp = this.resignationForm.get('empId').value;
    const empuID = this.resignationForm.get('id').value;
    // console.log(emp + 'emp');
    // console.log(empuID + 'empuID');
    skilFormData.append(
      'on_behalf_1',
      this.resignationForm.get('on_behalf_1').value
    );
    skilFormData.append('empId', this.resignationForm.get('empId').value);
    skilFormData.append(
      'rpls_rm_id',
      this.resignationForm.get('rpls_rm_id').value
    );

    skilFormData.append('emp_name', this.resignationForm.get('emp_name').value);
    skilFormData.append('on_behalf', this.behalfEmp);
    skilFormData.append('mobile', this.resignationForm.get('mobile').value);
    skilFormData.append('vltry_id', this.resignationForm.get('vltry_id').value);
    skilFormData.append('rsn_id', this.resignationForm.get('rsn_id').value);
    skilFormData.append(
      'resignDate',
      this.resignationForm.get('resignDate').value
    );
    // if (this.resignationForm.get('rsn_id').value == 69 || this.resignationForm.get('rsn_id').value == 73) {
    //   skilFormData.append('lastDate', '9999-12-31');
    // } else {
    skilFormData.append('lastDate', this.resignationForm.get('lastDate').value);
    // }
    skilFormData.append('uniform', this.resignationForm.get('uniform').value);
    skilFormData.append('comments', this.resignationForm.get('comments').value);
    skilFormData.append('win_back', this.resignationForm.get('win_back').value);
    skilFormData.append(
      'is_blacklist',
      this.resignationForm.get('is_blacklist').value
    );
    skilFormData.append('doc', this.docsFile);

    if (this.resignationForm.get('on_behalf_1').value == 1 && this.resignationForm.get('hiring_type').value != 8 && this.resignationForm.get('user_cate').value != 2) {
      Swal.fire({
        title:
          'Do you want to raise replacement MRF for this exiting Employee ?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          // console.log('on beaflh yes');
          this.exitService.addExitEmp(skilFormData).subscribe(
            (res) => {
              this.result = res;
              // console.log(this.result);
              this.submitted = false;
              if (this.result.status === true) {
                this.notifyService.showSuccess(this.result.msg, 'Success');
                if (this.resignationForm.get('on_behalf_1').value == '') {
                  this.router.navigate(['/dashboard']);
                }
                if (this.resignationForm.get('on_behalf_1').value == 1) {
                  const params = {
                    emp_user_id: this.behalfEmp,
                    creator_user_id: '',
                  };
                  this.createExitEmployeeMrf(params);
                  this.resignationForm.reset();
                  this.resignationForm.patchValue({
                    empId: emp,
                    id: empuID,
                    on_behalf_1: '1',
                  });
                }
              } else {
                this.notifyService.showError(this.result.msg, 'Error !');
              }
            },
            (err) => {
              this.submitted = false;
              this.notifyService.showError(err.error.msg, 'Error !');
            }
          );
        } else {
          //console.log('on beaflh no');
          this.submitExit(skilFormData);
        }
      });
    }
    else {
      console.log('self');
      // return;
      this.submitExit(skilFormData);
    }
  }

  submitExit(skilFormData): void {
    const emp = this.resignationForm.get('empId').value;
    const empuID = this.resignationForm.get('id').value;
    this.exitService.addExitEmp(skilFormData).subscribe(
      (res) => {
        this.result = res;
        //console.log(this.result);
        this.submitted = false;
        // this.loading = false;
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success');
          // this.resignationForm.reset();
          if (this.resignationForm.get('on_behalf_1').value == '') {
            this.router.navigate(['/dashboard']);
          }
          if (this.resignationForm.get('on_behalf_1').value == 1) {
            this.resignationForm.reset();
            this.resignationForm.patchValue({
              empId: emp,
              id: empuID,
              on_behalf_1: '1',
            });
          }
        } else {
          this.notifyService.showError(this.result.msg, 'Error !');
        }
      },
      (err) => {
        this.submitted = false;
        // this.loading = false ;
        this.notifyService.showError(err.error.msg, 'Error !');
      }
    );
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.docsFile = file;
    }
  }

  getClearanceChklist(empId): void {
    const params = {
      emp_id: empId,
      entity_id: 1,
    };
    this.exitService.getClearanceChklist(params).subscribe((res) => {
      this.result = res;
      this.clearanceList = this.result.data;
     // console.log(this.clearanceList);
    });
  }
  saveExitEmployee(i): void {
    const exitEmpFormData = new FormData();
    exitEmpFormData.append('chklst_value', this.clearanceList[i].status);
    // exitEmpFormData.append('chklst_amt', this.clearanceList[i].number);
    // exitEmpFormData.append('remark', this.clearanceList[i].remark);
    exitEmpFormData.append('emp_id', this.clearanceList[i].emp_id);
    exitEmpFormData.append('edit', this.clearanceList[i].edit_id);
    exitEmpFormData.append(
      'doc_attachment',
      this.clearanceList[i].doc_attachment
    );
    exitEmpFormData.append('chklst_id', this.clearanceList[i].chklst_id);
    exitEmpFormData.append('dept_id', this.clearanceList[i].dept_id);

    if (this.clearanceList[i].status == '') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select checklist status!',
      });
      return;
    }
    this.exitService.addClearanceChklist(exitEmpFormData).subscribe(
      (res) => {
        this.result = res;
        //console.log(res);
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success!');
          this.clearanceList[i].edit_id = this.result.edit_id;
          // this.getApprove();
        } else {
          this.notifyService.showError(this.result.msg, 'Error!');
        }
      },
      (err) => {
        this.notifyService.showError('Internal server Error', 'Error!');
      }
    );
  }

  finishExitEmpClearance(): void {
    const skilFormData = new FormData();
    skilFormData.append('empId', this.resignationForm.get('id').value);
    //console.log(this.resignationForm.get('id').value);
    // return;
    this.exitService.finishClearanceChklist(skilFormData).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success');
          this.router.navigate(['/dashboard']);
        } else {
          this.notifyService.showError(this.result.msg, 'Error');
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error');
      }
    );
  }

  checkEmpExitStatus(): void {
    this.exitService.checkEmpExitStatus().subscribe((res) => {
      this.result = res;
      this.exitStatus = this.result.is_user;
      if (
        (this.on_behalf_1 == 1 || this.exitStatus == true) &&
        this.clearanceList !== null
      ) {
        $('#exit_modal').modal('show');
      }
    });
  }

  createExitEmployeeMrf(mrfParams): void {
    //console.log(mrfParams);
    this.talentService.createExitEmployeeMrf(mrfParams).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status) {
          this.encMrfId = this.result.mrf_enc_id;
          this.router.navigate(['/talent/mrf/' + this.encMrfId]);
        } else {
          this.notifyService.showError(this.result.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error');
      }
    );
  }
}

// this.theDate = new Date();
//           this.myNewDate = new Date(this.theDate);
//           this.myNewDate.setDate(this.myNewDate.getDate() + this.slaValue);
//           this.myNewDate = this.formatDate(this.myNewDate);
//           console.log('this.myNewDate', this.myNewDate);
//           this.minReqdByDate = this.myNewDate;
